/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import router from '../../router/index'
import axios from 'axios';
import store from '../../store/index'
import { Message, LoadingBar } from 'iview';

// 环境的切换
if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = 'https://test.yizhiniao.com/';
    // axios.defaults.baseURL = 'http://192.168.2.127:8080/';//阿奔
} else if (process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
    if (process.env.NODE_HOST == 'production') {
        axios.defaults.baseURL = 'https://www.yizhiniao.com/';
    } else {
        axios.defaults.baseURL = 'https://test.yizhiniao.com/';
    }

}

// 请求超时时间
axios.defaults.timeout = 15000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// axios.defaults.headers.post['clientVersion'] = "web|";
// axios.defaults.headers.post['token'] = '';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        LoadingBar.start();
        // config.headers.token = '14f9dc4573e1457096ac394d9ef1cf72'
        config.headers.token = localStorage.getItem("malltk");
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        LoadingBar.finish();
        if (response.data.status == 200) {
            return Promise.resolve(response);
        } else {
            if (response.data.status == 20001) {
                localStorage.removeItem('malltk');
                Message.error({
                    background: true,
                    content: '用户认证失败,将在3秒内退出，请重新登录',
                    duration: 3
                });
                setTimeout(() => {
                    router.replace({
                        path: '/'
                    })
                }, 3000)
            } else {
                Message.error({
                    background: true,
                    content: response.data.message,
                    duration: 3
                });
            }
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        LoadingBar.error();
        console.log(error)
        let tip = '';
        if (error.response && error.response.status) {
            switch (error.response.status) {
                case 400:
                    tip = '数据填写有误，请检查后重新填写';
                    break;
                default:
                    tip = '发生了未知错误，请联系客服人员帮助您解决'
            }
        } else {
            if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
                tip = '请求超时，请稍后再试';
            } else {
                tip = '发生了未知错误，请联系客服人员帮助您解决';
            }
        }
        Message.error({
            background: true,
            content: tip,
            duration: 3
        });
        return Promise.reject(error);
    }
);
/**
 * 请求
 */
export function yznReq(methods, url, params) {
    return new Promise((resolve, reject) => {
        const r = methods == 'post' ? axios.post(url, JSON.stringify(params)) : axios.get(url, { params: params });
        r.then(res => {
            resolve(res.data);
        }).catch(err => {
            console.log('promise catch err')
            reject(err)
        })
    });
}


// WEBPACK FOOTER //
// ./src/assets/js/yznhttp.js